// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { ConnectionString } from '@models/connection-strings.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionStringsService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getConnectionStrings(): Observable<ConnectionString[]> {
    return this.http.get<ConnectionString[]>(`${this.globalService.apiUrl.url}/ConnectionStrings`, this.httpOptions);
  }

  postCreateConnectionString(connectionString: ConnectionString): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/ConnectionStrings`, connectionString, this.httpOptions);
  }

  getConnectionString(name: string): Observable<ConnectionString> {
    return this.http.get<ConnectionString>(`${this.globalService.apiUrl.url}/ConnectionStrings/${name}`, this.httpOptions);
  }

  putEditConnectionString(name: string, connectionString: ConnectionString): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/ConnectionStrings/${name}`, connectionString, this.httpOptions);
  }

  deleteConnectionString(name: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/ConnectionStrings/${name}`, this.httpOptions);
  }
}